import React from 'react';
import { ModalContent } from 'snacks-design-system';

interface componentProps {
  children: React.ReactNode;
  modNoPadding?: boolean;
  modFullHeight?: boolean;
  modCenterContent?: boolean;
}

const PIEModalContent = (props: componentProps) => {
  return <ModalContent {...props} />;
};

export default PIEModalContent;
